<ng-template #cartItemTemplate>
  <tr id="cart-item-{{ cartItem.id }}" class="cart-item-row">
    <td id="cart-item-{{ cartItem.id }}-product-name" class="cart-item-product-name">
      <span class="p-column-title" translate>cart-item.product-name</span>
      <div class="flex flex-column gap-xs">
        {{ cartItem.product.name }}
        <vnm-product-bundle [products]="cartItem.product?.bundledProducts"></vnm-product-bundle>
        <small *ngIf="cartItem.bulkDiscountApplied">
          <i translate>cart-item.bulk-discount-earned</i>
        </small>
        <vnm-promo-code-claim
          [record]="cartItem.promoCodeClaim"
          [promoCode]="cartItem.promoCode"
        ></vnm-promo-code-claim>
      </div>
    </td>
    <td id="cart-item-{{ cartItem.id }}-product-unit-price" class="cart-item-product-unit-price">
      <span class="p-column-title" translate>cart-item.product-price</span>
      <div [ngClass]="{ discounted: isDiscounted && !cartItem.splitPromo }">
        <span *ngIf="cartItem.splitPromo">{{ cartItem.quantityRemainder }} x</span>
        {{ cartItem.product.price | currency }}
      </div>
      <div *ngIf="isDiscounted">
        <span *ngIf="cartItem.splitPromo">{{ cartItem.promoPriceQuantity }} x</span>
        {{ cartItem.price | currency }}
      </div>
    </td>
    <td id="cart-item-{{ cartItem.id }}-product-quantity" class="cart-item-product-quantity">
      <span class="p-column-title" translate>cart-item.quantity</span>
      <p-inputNumber
        #quantityInput
        [showButtons]="true"
        [ngModel]="cartItem.quantity"
        (ngModelChange)="onQuantityChange($event)"
        [min]="1"
        [maxlength]="5"
      ></p-inputNumber>
    </td>
    <td id="cart-item-{{ cartItem.id }}-product-total-price" class="cart-item-product-total-price">
      <span class="p-column-title" translate>cart-item.total</span>
      {{ cartItem.total | currency }}
    </td>
    <td id="cart-item-{{ cartItem.id }}-product-actions" class="p-column-actions cart-item-product-actions">
      <span class="p-column-title" translate>app.actions</span>
      <vnm-destroy-node-button
        [node]="cartItem"
        [refetchQueries]="['LoadShoppingCart']"
        [iconOnly]="true"
        icon="fa fa-fw fa-times"
        [skipConfirmation]="true"
        success="cart-item.cart-item-removed"
        (done)="onRemovedFromCart(cartItem)"
      ></vnm-destroy-node-button>
    </td>
  </tr>
</ng-template>
